import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Import Types
import type { ConfigurationColumnData } from 'types';

export interface ReportColumnsSliceState {
    data: ConfigurationColumnData[];
}

export const initialState: ReportColumnsSliceState = {
    data: [],
};

export const reportColumnsSlice = createSlice({
    name: 'reportColumns',
    initialState,
    reducers: (create) => ({
        setReportColumns: create.reducer((state, { payload }: PayloadAction<ConfigurationColumnData[]>) => {
            state.data = [...payload];
        }),
        clearReportColumns: create.reducer((state) => {
            state.data = [];
        }),
    }),
    selectors: {
        selectReportColumns: (reportColumns) => reportColumns.data,
    },
});

export const { setReportColumns, clearReportColumns } = reportColumnsSlice.actions;
export const { selectReportColumns } = reportColumnsSlice.selectors;
